import {FC} from "react";
import {Card} from "react-bootstrap";
import useLaunchGoal from "@oldDashboard/legacyHooks/useLaunchGoal";
import Loader from "@/components/common/loader/loader";

interface LaunchGoalProps { launchGoal: String, affiliateSelected: String, launchSelected: String, timePeriodSelected: String, searching: boolean }
const LaunchGoalsTile: FC<LaunchGoalProps> = ({launchGoal, affiliateSelected, launchSelected, timePeriodSelected, searching}) => {
    const { isLoading } = useLaunchGoal({affiliateSelected, launchSelected, timePeriodSelected, searching});
    return (
        <Card className="custom-card overflow-hidden pb-4" style={{height: '250px'}}>
            { isLoading && <Loader/>}
            <Card.Body>
                <div className="row">
                    <div className="col-12">
                        <div>
                            <h4 className="fw-semibold mb-2">Launch Goals</h4>
                            <p className="mb-4 fs-16">
                                {launchGoal}
                            </p>
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default LaunchGoalsTile;
